// Use the globally-loaded Handlebars instance from the core app.
// Importing handlebars directly would create a separate instance with its own
// helper registry, which would conflict with (and clear) helpers registered by the core app.
// Access lazily (via function) so tests can stub globalThis.Handlebars in beforeEach.
const getHandlebars = () => (globalThis as any).Handlebars;

const compiledHandlebarsTemplates = {};

const defaultHelpers = [
  {
    name: 'ifEquals',
    function: `function(arg1, arg2, options) {return (arg1 === arg2) ? options.fn(this) : options.inverse(this);}`
  },
  {
    name: 'ifNotEquals',
    function: `function(arg1, arg2, options) {return (arg1 !== arg2) ? options.fn(this) : options.inverse(this);}`
  },
  {
    name: 'switch',
    function: `function(value, options) {this.switch_value = value;this.switch_break = false; return options.fn(this);}`
  },
  {
    name: 'case',
    function: `function(value, options) {if (value === this.switch_value) {this.switch_break = true;return options.fn(this);}}`
  },
  {
    name: 'default',
    function: `function(value, options) {if (this.switch_break === false) {return value;}}`
  },
  {
    name: 'dateFormat',
    function: `function(date, format, options) { return moment(date).format(format); }`
  },
  {
    name: 'dateAdd',
    function: `function(date, amount, what, options) { return moment(date).add(amount, what).format(); }`
  },
  {
    name: 'dateFromNow',
    function: `function(date, options) { return moment(date).fromNow(); }`
  },
  {
    name: 'dateToNow',
    function: `function(date, options) { return moment(date).toNow(); }`
  },
  {
    name: 'dateCalendar',
    function: `function(date, options) { return moment(date).calendar(); }`
  }
];

const sclHandlebars = (() => {
    return{
        initHandlebars(helpers) {
            for (let i = 0; i < defaultHelpers.length; i++) {
              if (typeof defaultHelpers[i].name === 'string' && typeof defaultHelpers[i].function === 'string') {
                const defaultHelps = new Function('return ' + defaultHelpers[i].function)();
                getHandlebars().registerHelper(defaultHelpers[i].name, defaultHelps);
              }
            }

            // If component has helpers defined add them in too
            if (typeof helpers !== 'undefined' && helpers !== null ) {
                for (const helper of helpers) {
                    if (typeof helper.name === 'string' && typeof helper.function === 'string') {
                        let helpFunc = helper.function;
                        if (typeof helpFunc === 'string') {
                            helpFunc = new Function('return ' + helpFunc)();
                        }

                        getHandlebars().registerHelper(helper.name, helpFunc);
                    }
                }
            }
        },

        defaultHelpers() {
          return defaultHelpers;
        },
        checkRegistedHelpers(helpers) {
            if (!helpers) { return; }
            let isRegistered = true;
            for (let i = 0; i < helpers.length ; i++) {
                if (typeof helpers[i].name === 'string' && typeof helpers[i].function === 'string') {
                    if (!(helpers[i].name in getHandlebars().helpers)) {
                        isRegistered = false;
                        break;
                    }
                }
            }
            if (!isRegistered) {
                sclHandlebars.initHandlebars(helpers);
            }
        },
        // throws an error instead of returning null
        processHandlebarsV2(handlebarsString, data, handlebarsContext?: any, helpers?, contextParams?, options?) {
            if (handlebarsString == null || typeof handlebarsString === 'undefined') {
                return '';
            }
            if ((typeof handlebarsString === 'string' || handlebarsString instanceof String)
            && (handlebarsString.indexOf('{{') < 0)) {
                return handlebarsString;
            }

            sclHandlebars.checkRegistedHelpers(helpers);
            let hStr;
            if (typeof handlebarsString === 'string') {
                hStr = handlebarsString;
            } else {
                hStr = JSON.stringify(handlebarsString);
            }

            if (!handlebarsContext) {
              handlebarsContext = {};
            }
            const invalidField = ['document', 'doc', 'account', 'tpl', 'componentDefinition'
            , 'results', 'resultsCount', 'resultsIndex', 'result', 'row'];
            if (data) {
                if (Object(data) === data) {
                    for (const f in data) {
                        if (f === 'queryResultDocument') {
                            handlebarsContext.row = data[f];
                            handlebarsContext.result = data[f];
                            for (const j in data[f]) {
                                if (data[f].hasOwnProperty(j)) {
                                    if (invalidField.indexOf(j) > -1) {
                                        console.log('Handlebars Context Error: the field ' + j
                                        + ' is already present in document documentId so could not be set.'
                                        + ' It\'s values will NOT be available to handlebars expressions.'
                                        + ' Please advise your Application Developer to not use this field name if possible');
                                        continue;
                                    }
                                    handlebarsContext[j] = data[f][j];
                                }
                            }

                        } else {
                            if (handlebarsContext.hasOwnProperty(f)) {
                                console.log('error : handlebarsString = ' + handlebarsString
                                + '\n\t data = ' + JSON.stringify(data)
                                + '\n\t handlebarsContext = ' + JSON.stringify(handlebarsContext)
                                + '\n\t helpers = ' + JSON.stringify(helpers));
                                continue;
                            }
                            handlebarsContext[f] = data[f];
                        }
                    }
                } else {
                    console.log('Handlebars Context Error: object ' + data + ' wasn\'t passed in and the parameters is being ignored');
                }
            }
            let result = null;
            try {
                let template;

                if (options?.handlebarsTemplateName && contextParams) {
                    const templateKey = `${contextParams?.tpl?.documentId}_${contextParams?.tplItem?.name}_${options.handlebarsTemplateName}`;
                    if (compiledHandlebarsTemplates[templateKey]) {
                        template = compiledHandlebarsTemplates[templateKey];
                    } else {
                        template = getHandlebars().compile(hStr);
                        compiledHandlebarsTemplates[templateKey] = template;
                    }
                } else {
                    template = getHandlebars().compile(hStr);
                }

                result = template(handlebarsContext);
            } catch (err) {
                err.hStr = hStr;
                throw err;
            }
            return result;
        },
        // backward compatibility purposes because it's still used in a lot of areas: returns a null object
        processHandlebars(handlebarsString, data, handlebarsContext?: any, helpers?, contextParams?, options?) {
          let result = null;
          try {
            if (contextParams) {
                if (!handlebarsContext) {
                    handlebarsContext = {};
                }
                handlebarsContext.document = contextParams.doc;
                handlebarsContext.doc = contextParams.doc;
                handlebarsContext.account = contextParams.account;
                handlebarsContext.tpl = contextParams.tpl;
                handlebarsContext.tplItem = contextParams.tplItem;
            }

            result = sclHandlebars.processHandlebarsV2(handlebarsString, data, handlebarsContext, helpers, contextParams, options);
          } catch (err) {
            console.error(err);
          }
          return result;
        },
        processIntHandlebars(handlebarsString, data, handlebarsContext?: any, helpers?, contextParams?, options?) {
            const hStr = sclHandlebars.processHandlebars(handlebarsString, data, handlebarsContext, helpers, contextParams, options);
            if (hStr) {
                return parseInt( hStr, 0 );
            } else { return 0; }
        },
        processFloatHandlebars(handlebarsString, data, handlebarsContext?: any, helpers?, contextParams?, options?) {
            const hStr = sclHandlebars.processHandlebars(handlebarsString, data, handlebarsContext, helpers, contextParams, options);
            if (hStr) {
                return parseFloat( hStr );
            } else { return 0; }
        },
        processBooleanHandlebars(handlebarsString, data, handlebarsContext?: any, helpers?, contextParams?, options?) {
            return  sclHandlebars.processHandlebars(handlebarsString, data, handlebarsContext, helpers, contextParams, options) === 'true';
        },
        processArrayHandlebars(handlebarsString, data, handlebarsContext?: any, helpers?, contextParams?, options?) {
            let hStr = sclHandlebars.processHandlebars(handlebarsString, data, handlebarsContext, helpers, contextParams, options);
            if (hStr) {
                try {
                    let arr = [];

                    if (typeof hStr === 'string' && hStr.indexOf(',') > -1) {
                        if (hStr.indexOf('[') > -1) {
                            hStr = hStr.replace('[', '');
                        }
                        if (hStr.indexOf(']') > -1) {
                            hStr = hStr.replace(']', '');
                        }
                        const s = hStr.split(',');
                        if (s?.length === 2
                             && (!isNaN(Number(s[0].trim())) && !isNaN(parseFloat(s[0].trim())))
                             && (!isNaN(Number(s[1].trim())) && !isNaN(parseFloat(s[1].trim())))) {
                            arr = [parseFloat(s[0].trim()), parseFloat(s[1].trim())];
                        }
                    } else {
                        const obj = JSON.parse( hStr );
                        for (const i in obj) {
                            if (obj.hasOwnProperty(i)) {
                                arr.push(obj[i]);
                            }
                        }
                    }
                    return arr;
                } catch (err) {
                    return null;
                }
            } else {
                return null;
            }
        }
    };
})();

export { sclHandlebars };
